import { CarType, IODLayerName, ODDataType, ODYearType } from "./IODLayerName";

/** 発集量_Bゾーン_乗用車レイヤ名 */
const LAYER_OD_BTZ_BZONE_PASSENGER_CAR = "t_od_btz_bzone_passenger_car";
/** 発集量_Bゾーン_小型貨物車レイヤ名 */
const LAYER_OD_BTZ_BZONE_SMALL_CARGO = "t_od_btz_bzone_small_cargo";
/** 発集量_Bゾーン_普通貨物車レイヤ名 */
const LAYER_OD_BTZ_BZONE_NORMAL_CARGO = "t_od_btz_bzone_normal_cargo";
/** 発集量_Bゾーン_車種計レイヤ名 */
const LAYER_OD_BTZ_BZONE_TOTAL = "t_od_btz_bzone_total";
/** 発集量_市区町村_乗用車レイヤ名 */
const LAYER_OD_BTZ_CITY_PASSENGER_CAR = "t_od_btz_city_passenger_car";
/** 発集量_市区町村_小型貨物車レイヤ名 */
const LAYER_OD_BTZ_CITY_SMALL_CARGO = "t_od_btz_city_small_cargo";
/** 発集量_市区町村_普通貨物車レイヤ名 */
const LAYER_OD_BTZ_CITY_NORMAL_CARGO = "t_od_btz_city_normal_cargo";
/** 発集量_市区町村_車種計レイヤ名 */
const LAYER_OD_BTZ_CITY_TOTAL = "t_od_btz_city_total";
/** 発集量_都道府県_乗用車レイヤ名 */
const LAYER_OD_BTZ_PREF_PASSENGER_CAR = "t_od_btz_pref_passenger_car";
/** 発集量_都道府県_小型貨物車レイヤ名 */
const LAYER_OD_BTZ_PREF_SMALL_CARGO = "t_od_btz_pref_small_cargo";
/** 発集量_都道府県_普通貨物車レイヤ名 */
const LAYER_OD_BTZ_PREF_NORMAL_CARGO = "t_od_btz_pref_normal_cargo";
/** 発集量_都道府県_車種計レイヤ名 */
const LAYER_OD_BTZ_PREF_TOTAL = "t_od_btz_pref_total";

/**
 * OD発集量レイヤ指定用クラス
 */
export class ODSumDeparturesArrivalsLayerName implements IODLayerName {
  /**
   * データ種別
   */
  odDataType: ODDataType;

  /**
   * 車種
   */
  carType: CarType;

  /**
   * 年度
   */
  yearType: ODYearType;

  /**
   * 発集種別
   */
  btzType: string;

  /**
   * 時刻
   */
  time: string;

  /**
   * コンストラクタ
   * @param odDataType データ種別
   * @param carType 車種
   * @param yearType 年度
   * @param btzType 発集種別
   * @param time 時間帯（24で全時間帯）
   */
  constructor(
    odDataType: ODDataType,
    carType: CarType,
    yearType: ODYearType,
    btzType: string,
    time: number | string
  ) {
    this.odDataType = odDataType;
    this.carType = carType;
    this.yearType = yearType;
    this.btzType = btzType;
    // "00" - "24" の文字列にフォーマット
    this.time = time.toString().padStart(2, "0");
  }

  /**
   * フィルタ条件文字列を取得
   */
  getCqlFilterString(): string {
    return `"年度"='${this.yearType}' AND "時刻"='${
      this.time
    }' AND "発集種別"=${this.getBtzTypeId()}`;
  }

  /**
   * レイヤ名を取得
   */
  getLayerName(): string {
    let layerName = "";
    if (this.odDataType === "Bゾーン") {
      switch (this.carType) {
        case "乗用車":
          layerName = LAYER_OD_BTZ_BZONE_PASSENGER_CAR;
          break;
        case "小型貨物車":
          layerName = LAYER_OD_BTZ_BZONE_SMALL_CARGO;
          break;
        case "普通貨物車":
          layerName = LAYER_OD_BTZ_BZONE_NORMAL_CARGO;
          break;
        case "車種計":
          layerName = LAYER_OD_BTZ_BZONE_TOTAL;
          break;
      }
    } else if (this.odDataType === "市区町村") {
      switch (this.carType) {
        case "乗用車":
          layerName = LAYER_OD_BTZ_CITY_PASSENGER_CAR;
          break;
        case "小型貨物車":
          layerName = LAYER_OD_BTZ_CITY_SMALL_CARGO;
          break;
        case "普通貨物車":
          layerName = LAYER_OD_BTZ_CITY_NORMAL_CARGO;
          break;
        case "車種計":
          layerName = LAYER_OD_BTZ_CITY_TOTAL;
          break;
      }
    } else if (this.odDataType === "都道府県") {
      switch (this.carType) {
        case "乗用車":
          layerName = LAYER_OD_BTZ_PREF_PASSENGER_CAR;
          break;
        case "小型貨物車":
          layerName = LAYER_OD_BTZ_PREF_SMALL_CARGO;
          break;
        case "普通貨物車":
          layerName = LAYER_OD_BTZ_PREF_NORMAL_CARGO;
          break;
        case "車種計":
          layerName = LAYER_OD_BTZ_PREF_TOTAL;
          break;
      }
    }
    return layerName;
  }

  /**
   * CQLフィルタ用 発集種別に対応する番号を返す
   * @returns CQLフィルタ用の種別番号
   */
  private getBtzTypeId(): number {
    switch (this.btzType) {
      case "発生量":
        return 1;
      case "集中量":
        return 2;
      case "発生集中量":
        return 3;
      default:
        throw new Error("Invalid value given for parameter layerName.btzType.");
    }
  }
}
